module.exports = __webpack_public_path__ + "img/banner.e749842f.png";